import { createSlice } from '@reduxjs/toolkit';
import { TableState } from '../../components/table/model';

const initialState: TableState = {
  columns: [],
};

const transactiontypeListSlice = createSlice({
  name: 'transactiontypeTable',
  initialState,
  reducers: {
    hideColumn(state) {},
  },
});

export const transactiontypesReducer = transactiontypeListSlice.reducer;
